import list from "emun.media/media-container.list.htm";
import cards from "emun.media/media-container.cards.htm";

export default {
  list,
  cards,
};
